<template>
  <div id="app">
    <div class="container">
        <div class="columns">
          <div class="column auto"></div>
          <div class="column is-one-third">
            <img alt="Dagbladet Pluss" src="./assets/dagbladetpluss.png" class="column" style="height: auto; max-height: 100px; display: inline">
          </div>
          <div class="column auto"></div>
        </div>
    </div>
    <DagbladetForm msg="Ønsker du å si opp abonnementet på Dagbladet Pluss? Fyll ut feltene nedenfor og trykk &quot;Send Inn&quot;. Din oppsigelse blir behandlet i løpet av 48 timer."/>
  </div>
</template>

<script>
import DagbladetForm from './components/DagbladetForm.vue'

export default {
  name: 'App',
  components: {
    DagbladetForm
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
